import React from "react";
import TextInput from "_c/form/TextInput";
import FormSect from "_c/form/Sect";
import Label from "_c/form/Label";
import PT from "prop-types";
import { useForm } from "react-hook-form";
import { ORDERS_NS } from "@/i18n/ns";
import { Footer, Content } from "_c/Modals";

const ns = `${ORDERS_NS}:cancel_form`;
const formId = "task-cancel-form";
const CancelTask = ({ task, t, ...props }) => {
  const { handleSubmit, register, formState } = useForm({
    defaultValues: {
      reason: "",
    },
  });
  const id = `${task._id}-note`;
  const onSubmit = async (form) => {
    await props.onCancel(form);
  };
  return (
    <>
      <Content id={formId} as="form" onSubmit={handleSubmit(onSubmit)}>
        <FormSect>
          <Label htmlFor={id}>{t(`${ns}.label`)}</Label>
          <TextInput
            required
            autoFocus
            t={t}
            rows="5"
            autoComplete="off"
            id={id}
            ref={register}
            name="reason"
            placeholder={t(`${ns}.placeholder`)}
            as="textarea"
          />
        </FormSect>
      </Content>
      <Footer disabled={formState.isSubmitting} form={formId} type="submit">
        {t(`common:accept`)}
      </Footer>
    </>
  );
};
CancelTask.propTypes = {
  task: PT.object,
  onCancel: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default CancelTask;
